import "./StatusIndicator.scss"

import React, { FunctionComponent } from "react"
import Spinner from "components/Spinner/Spinner"

export enum StatusIndicatorState {
    grey = "grey",
    green = "green",
    red = "red",
    yellow = "yellow",
    loading = "loading",
}

interface IStatusIndicatorProps {
    state?: StatusIndicatorState
}

const StatusIndicator: FunctionComponent<React.PropsWithChildren<IStatusIndicatorProps>> = ({
    state = StatusIndicatorState.grey
}) => {
    return (
        <div
            role="status"
            className={`status-indicator status-indicator--${state}`}>
            {state === StatusIndicatorState.loading &&
                <Spinner size={24} />
            }
        </div>
    )
}

export default StatusIndicator
